module.exports = __webpack_public_path__ + "static/media/properties.d28f3684.svg";